import { render } from "./SleepMobileRedirect.vue?vue&type=template&id=40d20931&scoped=true&ts=true&lang=pug"
import script from "./SleepMobileRedirect.vue?vue&type=script&lang=ts"
export * from "./SleepMobileRedirect.vue?vue&type=script&lang=ts"

import "./SleepMobileRedirect.vue?vue&type=style&index=0&id=40d20931&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./SleepMobileRedirect.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/sleep/SleepMobileRedirect.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fviews%2FSleep%2FSleepMobileRedirect.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d20931"]])

export default __exports__